<template>
  <a-modal v-model="show" centered title="修改密码" :maskClosable="false" :closable="true" :keyboard="false" :centered="true">
    <template slot="footer">
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleSave">修改</a-button>
    </template>
    <a-form-model layout="horizontal" ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
      <a-form-model-item label="账号">
        {{userInfo.adminName}}
      </a-form-model-item>
      <a-form-model-item ref="password" label="原始密码" prop="password">
        <a-input v-model="form.password" placeholder="输入原始密码"/>
      </a-form-model-item>
      <a-form-model-item ref="npassword" label="新密码" prop="npassword">
        <a-input v-model="form.npassword" placeholder="输入新密码"/>
      </a-form-model-item>
      <a-form-model-item ref="npassword1" label="再次输入新密码" prop="npassword1">
        <a-input v-model="form.npassword1" placeholder="输入重复新密码"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
  import {
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex';
  import {
    modifyPassword
  } from '@/api/sys.api';
  import Utils from '../../libs/utils.js';
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
    },
    watch: {},
    data() {
      const validatePass = (rule, value, callback) => {
        if(value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.form.npassword !== '') {
            this.$refs.form.validateField('npassword1');
          }
          callback();
        }
      }
      const validatepasssure = (rule, value, callback) => {
        if(value === '') {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.form.npassword) {
          callback(new Error('两次新密码输入错误，请重新输入'));
        } else {
          callback();
        }
      }
      return {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
        form: {
          password: '', // 原始密码
          npassword: '', // 新密码
          npassword1: '', //重复新密码
        },
        loading: false, //修改等待
        rules: {
          password: [{ required: true, message: '请输入旧密码', trigger: 'change'}],
          npassword: [{ required: true, validator: validatePass, trigger: 'change'}],
          npassword1: [{ required: true, validator: validatepasssure, trigger: 'change'}]
        }
      }
    },
    computed: {
      ...mapGetters(["userInfo"]),
    },
    mounted() {
      let that = this;
    },
    methods: {
      handleCancel(e){
        this.$emit('closed');
        this.form = {
          password: '', // 原始密码
          npassword: '', // 新密码
          npassword1: '', //重复新密码
        }
      },
      handleSave(e){
        let that = this;
        that.$refs.form.validate(valid => {
          if (valid) {
            let obj = {
              ...that.form,
            }
            modifyPassword(obj).then(res=>{
              if(res.code == '0') {
                that.$message.success(res.message);
                that.handleCancel();
              } else {
                that.$message.error(res.message);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/main/editPwd.vue